import { Checkbox } from '@/components/ui/checkbox';

import { accountLabel } from './group-templates';

interface AccountCheckboxListProps {
  accounts: Array<{ waba_id: string; name: string | null }>;
  selected: string[];
  onToggle: (wabaId: string, checked: boolean) => void;
  disabled?: boolean;
}

/** A checkbox per WhatsApp Business Account, showing the account name with its WABA id. */
export const AccountCheckboxList = ({
  accounts,
  selected,
  onToggle,
  disabled,
}: AccountCheckboxListProps) => (
  <ul className="space-y-2">
    {accounts.map((account) => {
      const id = `waba-${account.waba_id}`;
      const label = accountLabel(account);
      return (
        <li key={account.waba_id} className="flex items-start gap-2">
          <Checkbox
            id={id}
            checked={selected.includes(account.waba_id)}
            onCheckedChange={(checked) => onToggle(account.waba_id, checked === true)}
            disabled={disabled}
            className="mt-0.5"
          />
          <label htmlFor={id} className="cursor-pointer text-sm leading-tight">
            {label}
            {label !== account.waba_id && (
              <span className="text-muted-foreground ml-1 font-mono text-xs">
                {account.waba_id}
              </span>
            )}
          </label>
        </li>
      );
    })}
  </ul>
);
